import React, { useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import numWords from "num-words";
import Logo from "../../assets/icons/logo.png";
import { amountToWords, numberToWords } from "amount-to-words";

const Invoice = ({ order, products }) => {
  const invoiceRef = useRef();

  const downloadPDF = () => {
    const input = invoiceRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`${order.invoice_number}.pdf`);
    });
  };

    const amountInWord = (value = 0)=>{
  
      var text = "";
      var res =amountToWords(value, 2);
      console.log("res", res);
      
       text = `${res.numberInWords} Rupees`;
      if(res.decimalInWords){
        text = `${text} and ${res.decimalInWords} Paisa`;
      }
      return text;
    }
  


  return (
    <div
      className="p-6"
      style={{
        width: "850px",
      }}
    >
      <button
        onClick={downloadPDF}
        className="mb-4 bg-blue-600 text-white px-4 py-2 rounded"
      >
        Download PDF
      </button>
      <div className="border">
        <div
          ref={invoiceRef}
          className="bg-white text-black max-w-4xl mx-auto  p-10 text-sm font-sans"
        >
          {/* Header */}
          <div className="flex justify-between items-start border-b pb-4">
            <div>
              <h1 className="text-3xl font-bold uppercase mb-3">Tax Invoice</h1>
              <h3 className="text-xl font-bold uppercase">
                Invoice No:# {order.invoice_number}
              </h3>
              <p className="text-mb uppercase">Date: {order.order_date}</p>
              <p className="text-mb uppercase">Status: {order.status}</p>
            </div>
            <div className="text-right">
              <h2 className="font-semibold">First Floor</h2>
              <p>2nd Floor, De Ja Gow Building</p>
              <p>Vijaynagar 1st stage, Mysore</p>
              <p>Karnataka - 570017</p>
              <p>Contact: 7892327428</p>
            </div>
          </div>

          {/* Buyer / Shipping Info */}
          <div className="flex justify-between mt-4 border-b pb-4">
            <div className="max-w-[300px]">
              <h3 className="font-semibold mb-1">Billed To:</h3>
              <p className="font-semibold text-md uppercase mb-1">
                {order.customer_obj.billing_name}
              </p>
              <p>
                {order.customer_obj.billing_address},{" "}
                {order.customer_obj?.billingCity?.name},{" "}
                {order.customer_obj?.billingState?.name}
              </p>
              <p>Pincode: {order.customer_obj.billing_pincode}</p>
              <p>
                Place of Supply:
                {order.customer_obj?.billingState?.name} ({" "}
                {order.customer_obj?.billingState?.code})
              </p>
              <p>Phone: {order.customer_obj.contact_number}</p>
            </div>
            <div className="w-[250px]">
              <div className="max-w-[250px]">
                <h3 className="font-semibold">Shipped To:</h3>
                <p className="font-semibold mb-1">
                  {order.customer_obj.customer_delivery_addresses?.name}
                </p>
                <p>
                  {order.customer_obj.customer_delivery_addresses?.address},
                  {order.customer_obj.customer_delivery_addresses?.city.name},{" "}
                  {order.customer_obj.customer_delivery_addresses?.state.name},
                </p>
                <p>
                  Pincode:{" "}
                  {order.customer_obj.customer_delivery_addresses?.pincode}
                </p>
                <p>
                  State:{" "}
                  {order.customer_obj.customer_delivery_addresses.state?.name} (
                  {order.customer_obj.customer_delivery_addresses.state?.code})
                </p>
                <p>Transport Vehical No: {order.transport_vehical_number}</p>
              </div>
            </div>
          </div>

          {/* Products Table */}
          <table className="w-full border-collapse mt-4 text-xs">
            <thead>
              <tr className="bg-gray-200">
                <th className="border px-2 py-1">#</th>
                <th className="border px-2 py-1">Name</th>
                <th className="border px-2 py-1">HSN</th>
                <th className="border px-2 py-1">Qty</th>
                <th className="border px-2 py-1">Rate</th>
                <th className="border px-2 py-1">Amount</th>
              </tr>
            </thead>
            <tbody>
              {products.map((p, i) => (
                <tr key={p.id}>
                  <td className="border px-2 py-1 text-center">{i + 1}</td>
                  <td className="w-[25ch] border px-2 pt-1 pb-2">{p.name} </td>
                  <td className="w-[8ch] border px-1 py-1 text-center">
                    {p.hsn_code}
                  </td>
                  <td className="border w-[3ch] px-2 py-1 text-center">
                    {p.quantity}
                  </td>
                  <td className="border w-[10ch]  px-2 py-1 text-center">
                    ₹{p.cash_amount}
                  </td>
                  <td className="border px-2 py-1 text-right">
                    ₹{p.total_cash_amount}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Totals */}
          <div className="flex justify-end mt-6">
            <div className="text-right">
              <p>Sub Total: ₹{order.total_cash_amount}</p>
              <p className="font-bold text-base">
                Grand Total: ₹{order.total_cash_amount}
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-6 text-xs border-t pt-2">
            <p>
              Amount in Words:{" "}
              <em className="capitalize">
                Indian Rupees {amountInWord(order.total_cash_amount)} only.
              </em>
            </p>
            <p className="mt-2">
              Declaration: We declare that this invoice shows the actual price
              of goods or services and all particulars are true and correct.
            </p>
            <div className="flex justify-between mt-[150px]">
              <p>Customer Signature</p>
              <p>Authorized Signatory</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const InvoiceModal = ({
  isOpen = false,
  onClose = () => {},
  order = {},
  products = [],
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-5"
          onClick={handleOverlayClick}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-[60rem] w-full h-full md:p-6 p-4 relative overflow-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <Invoice order={order} products={products} />
          </div>
        </div>
      )}
    </>
  );
};

export default InvoiceModal;
